var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"xl":_vm.cols}},[_c('div',{staticClass:"stats-title"},[_c('h5',{staticClass:"mb-0 text-info"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_c('h5',{staticClass:"mb-2 text-gray"},[_c('strong',[_vm._v(_vm._s(_vm.text))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }